module.exports = __webpack_public_path__ + "static/13-f8bdcc65de0749b120b19d1a74f02f74.png";